import * as TradeActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageTrade = {
  items: [],
  params: defaultParams
};

const TradeProfile = {
  id: '',
  name: '',
  isActive: true
};

const TradeState = {
  ManageTrade: ManageTrade,
  TradeProfile: TradeProfile,
  ErrorMsg: [],
  IsOpenFormAddEdit: false,
  Title: 'New trade',
  IsCreate: true,
  dateTime: new Date(),
  TradeList: [],
  ItemRepairList: [],
  TradeSelectListBySubcontractor: [],
  BlueTapeItemRepairList:[]
};

export default function TradeStore(state = TradeState, action) {
  switch (action.type) {
    case TradeActionType.SEARCH_TRADE_SUCCESS:
      return processSearchSuccess(state, action);
    case TradeActionType.OPEN_FORM_CREATE_TRADE:
      return {
        ...state,
        TradeProfile: TradeProfile,
        Title: 'New trade',
        ErrorMsg: [],
        IsCreate: true,
        IsOpenFormAddEdit: true,
        dateTime: new Date()
      };
    case TradeActionType.CLOSE_FORM_CREATE_TRADE:
      return {
        ...state,
        ErrorMsg: [],
        IsOpenFormAddEdit: false
      };
    case TradeActionType.GET_TRADE_BY_ID_SUCCESS:
      return processGetTradeByIdSuccess(state, action);
    case TradeActionType.ADD_EDIT_TRADE_ERROR:
      return processAddEditTradeError(state, action);
    case TradeActionType.RESET_TRADE:
      return {
        ...state,
        ManageTrade: {
          ...state.ManageTrade,
          params: defaultParams
        }
      };
    case TradeActionType.SELECT_LIST_TRADE_SUCCESS:
      return processSelectTradeSuccess(state, action);
    case TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS:
      return {
        ...state,
        ItemRepairList: action.data
      };
    case TradeActionType.FETCH_LIST_ITEM_REPAIR_BY_TRADEID_SUCCESS:
      return {
        ...state,
        BlueTapeItemRepairList: action.data
      };  
    case TradeActionType.SELECT_LIST_TRADE_BY_SUBCONTRACTOR_ID_SUCCESS:
      return {
        ...state,
        TradeSelectListBySubcontractor: action.data
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageTrade = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageTrade: manageTrade,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processGetTradeByIdSuccess = (state, action) => {
  return {
    ...state,
    TradeProfile: action.data,
    Title: 'Edit trade',
    ErrorMsg: [],
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processAddEditTradeError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    TradeProfile: {
      ...state.TradeProfile,
      name: action.data.params.name
    }
  };
};

const processSelectTradeSuccess = (state, action) => {
  return {
    ...state,
    TradeList: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Trades/reducers.js